<article class="manage-license-card" data-testid="license-manager-batch">
  <div class="card-head">
    <div class="card-title-block">
      <h4>{{ batchTitle }}</h4>
      <span *ngIf="batch.id">ID: {{ batch.id }}</span>
    </div>
    <div class="card-actions">
      <button
        class="icon-action-btn"
        type="button"
        aria-label="Open license batch details in a new tab"
        matTooltip="Open details in new tab"
        [disabled]="!batch.id"
        (click)="openDetails.emit()"
      >
        <mat-icon>open_in_new</mat-icon>
      </button>
      <button
        class="icon-action-btn"
        type="button"
        data-testid="license-manager-batch-link"
        [attr.aria-label]="linkActionLabel"
        [matTooltip]="linkActionLabel"
        [disabled]="!batch.id || processing"
        (click)="changeLink.emit()"
      >
        <mat-icon>{{ linkActionIcon }}</mat-icon>
      </button>
    </div>
  </div>
  <p>{{ batch.description || 'No description provided.' }}</p>
  <div class="card-chip-list">
    <span>Product: {{ productLabel }}</span>
    <span>Scope: {{ scopeLabel }}</span>
    <span>Batch size: {{ batch.licenseBatchSize ?? 0 }}</span>
    <span *ngIf="batch.optionalValidAfter">
      Valid from: {{ formatDate(batch.optionalValidAfter) }}
    </span>
    <span *ngIf="batch.optionalValidBefore">
      Valid to: {{ formatDate(batch.optionalValidBefore) }}
    </span>
  </div>
</article>
